import { Api } from '@monorepo/shared/apiClient';
import { getQueryConfig } from '@monorepo/shared/utils/queryUtils';
import { QueryConfig, useQuery } from 'react-query';

type UseFormPreviewParams = Partial<Api.FetchFormPreviewParams> & {
  config?: QueryConfig<Api.FetchFormPreviewResponse, Api.ErrorResponse>;
};

type KeyParams = Api.FetchFormPreviewParams;

const KEY_START = 'form-preview';
export const createKey = ({
  organizationId,
  projectId,
  formTemplate,
}: KeyParams) => [KEY_START, organizationId, projectId, formTemplate] as const;

type Fetcher = Api.DataHookQueryFn<
  typeof createKey,
  typeof Api.fetchFormPreview
>;

const fetcher: Fetcher = (_, organizationId, projectId, formTemplate) =>
  Api.fetchFormPreview({ organizationId, projectId, formTemplate });

export const useFormPreview = ({
  config: inputConfig,
  organizationId,
  projectId,
  formTemplate,
}: UseFormPreviewParams) => {
  const isEnabled = !!organizationId && !!projectId && !!formTemplate;
  const config = getQueryConfig(inputConfig, isEnabled);
  const key = isEnabled
    ? createKey({ organizationId, projectId, formTemplate })
    : undefined;
  const { data, ...queryInfo } = useQuery(key, fetcher, config);

  return {
    ...queryInfo,
    formSubmissionTemplate: data,
  };
};
